import Vue from 'Vue';
export default new Vue;


// WEBPACK FOOTER //
// ./src/assets/utils/eventBus.js